// 角色管理相关API接口
import request from '@/utils/request'

/**
 * 获取角色 带分页
 * @param params
 * @param data
 * @returns {*}
 */
export function getRolePage(params,data) {
    return request({
        url: '/role/page/low',
        method: 'post',
        data,
        params
    })
}

/**
 * 获取角色列表
 * @param data
 * @returns {*}
 */
export function getRoleList(params) {
    return request({
        url: '/role/list',
        method: 'get',
        params
    })
}
/**
 * 删除角色
 * @param data 整个对象
 * @returns {*}
 */
export function delRole(data) {
    return request({
        url: '/role',
        method: 'delete',
        data
    })
}
/**
 * 添加角色
 * @param data
 * @returns {*}
 */
export function addRole(data) {
    return request({
        url: '/role',
        method: 'post',
        data
    })
}
/**
 * 更新角色
 * @param data
 * @returns {*}
 */
export function updateRole(data) {
    return request({
        url: '/role',
        method: 'put',
        data
    })
}

/**
 * 检查角色是否存在
 * @param data 有code就行
 * @returns {*}
 */
export function existRole(data) {
    return request({
        url: '/role/exist',
        method: 'post',
        data
    })
}

/**
 * 指定角色的权限列表
 * @param roleId
 * @returns {*}
 */
export function listByRoleId(roleId) {
    return request({
        url: '/role/'+ roleId+'/interface',
        method: 'get'
    })
}
